import {gql} from '@apollo/client';
import {useQuery} from '@apollo/client/react';
import {useFirebaseAuthSimplified} from '@coolcolduk/ui-firebase-helper';
import {Auth} from 'firebase/auth';
import {noop} from 'lodash';
import {useEffect, useState} from 'react';
import {UserAccount} from '../__generated__/resolvers-types';
import withFirebaseToken from '../util/firebase/withFirebaseToken';

export const GET_USER_QUERY = gql`
  query GetUserQuery {
    getUser {
      uid
      email
      emailVerified
      displayName
      photoURL
      createdAt
      lastLoginAt
      permissions
      role
    }
  }
`;

/**
 * Get and monitor user authentication
 * @returns object with user data and refetch function
 */
export default function useGetUser(firebaseAuth: Auth): {
  user: undefined | null | UserAccount;
  refetch: () => Promise<any>;
  loading: boolean;
} {
  const [data, setData] = useState<undefined | null | UserAccount>(undefined);
  const firebaseUser = useFirebaseAuthSimplified(firebaseAuth);

  const user = useQuery<{getUser: UserAccount}>(GET_USER_QUERY, {
    skip: !firebaseUser,
  });

  useEffect(() => {
    withFirebaseToken((token) => {
      // loading
      if (firebaseUser === undefined) {
        setData(undefined);
        return noop;
      }

      if (firebaseUser === null || !token) {
        // not logged in
        setData(null);
        return noop;
      }
      return noop;
    });
  }, [firebaseUser]);

  useEffect(() => {
    if (user.loading || !firebaseUser) {
      return;
    }
    setData(user.data ? user.data.getUser : null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return {
    user: data,
    refetch: user.refetch,
    loading: user.loading,
  };
}
